/*
Version 0.115

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2021
	20-01-2021
	- [BORN] This class is born. Hooray!

!Usage
	specific_mobilemenu.onready();

	
!Wishlist

	none
	
*/
  
var specific_client = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	
	this.onready = function() {

		/*
		Listener
		*/
		$(document).on('click','.js-client-submit',function() {
			specific_client.save();
		});
	
	};
	 
	// METHODS  *****************************************************************
	// METHODS *****************************************************************
	// METHODS ******************************************************************
	// METHODS ******************************************************************

	/*
	Save *************************
	Save *************************
	Save *************************
	Save *************************
	*/
	this.save = function(
	) {

		var _client_id 				= $('.js-client-id').val();
		var _client_exact_id       	= $('.js-client-exact-id').val();
		var _client_firstname       = $('.js-client-firstname').val();
        var _client_lastname        = $('.js-client-lastname').val();
        var _client_streetname      = $('.js-client-streetname').val();
        var _client_streetnumber    = $('.js-client-streetnumber').val();
        var _client_zipcode         = $('.js-client-zipcode').val();
        var _client_city            = $('.js-client-city').val();
        var _client_telephone       = $('.js-client-telephone').val();
        var _client_emailaddress    = $('.js-client-emailaddress').val();


        /*
		Show: Modal
		*/
		modal.open('loading');
		
        /*
		XHR: Exact.php first
		XHR: Exact.php first
		XHR: Exact.php first
		XHR: Exact.php first
		*/

		// $.ajax({
		// 	url: globalUrl + '/exact.php',
		// 	data: {
		// 		'what':'klant'
		// 	},
		// 	type: "POST",
		// 	headers: { 
		// 		'go-load':1
		// 	}
		// })
		// .done(function(data) {

		// 	setTimeout(function() {
				
		/*
		Ajax
		*/
		$.ajax({
			url: globalUrl + '/a/a/client-action',
			type: "POST",
			data: {
				client_id 			: _client_id,
				client_exact_id 	: _client_exact_id,
				client_firstname 	: _client_firstname,
				client_lastname		: _client_lastname,
				client_streetname 	: _client_streetname,
				client_streetnumber	: _client_streetnumber,
				client_zipcode 		: _client_zipcode,
				client_city 		: _client_city,
				client_telephone 	: _client_telephone,
				client_emailaddress : _client_emailaddress,
			},
			headers: { 
				'go-load':1 
			}
		})
		.done(function(data) {

			/*
			Notifier
			*/
			if(_client_id == 'new') {
				notifier.show(
					'Klant toegevoegd'
				);
			} else {
				notifier.show(
					'Klant aangepast'
				);
			}

			/*
			Close popup and modal
			*/
			modal.close();
			popup.close();

		})
		.always(function() {
		});

		// 	},1000);

		// })
		// .always(function() {
		// });

	};
		
}).apply(specific_client); 